"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ContentEditable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ContentEditable, _React$Component);
  var _super = _createSuper(ContentEditable);
  function ContentEditable() {
    var _this;
    (0, _classCallCheck2["default"])(this, ContentEditable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "shouldComponentUpdate", function (nextProps) {
      return nextProps.html !== _this.ref.innerHTML;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidUpdate", function () {
      if (_this.props.html !== _this.ref.innerHTML) {
        _this.ref.innerHTML = _this.props.html;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "emitChange", function () {
      var html = _this.ref.innerHTML;
      if (_this.props.onChange && html !== _this.lastHtml) {
        _this.props.onChange({
          target: {
            value: html
          }
        });
      }
      _this.lastHtml = html;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (e) {
      if (typeof _this.props.onKeyDown === 'function') _this.props.onKeyDown(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "render", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(r) {
          return _this.ref = r;
        },
        className: "content-editable",
        onInput: _this.emitChange,
        onBlur: _this.emitChange,
        onKeyDown: _this.onKeyDown,
        contentEditable: true,
        dangerouslySetInnerHTML: {
          __html: _this.props.html
        }
      });
    });
    return _this;
  }
  return (0, _createClass2["default"])(ContentEditable);
}(_react["default"].Component);
var _default = ContentEditable;
exports["default"] = _default;